<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">利用状況</div>
      </md-card-header>

      <md-card-content v-if="errorMessages.length">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <div class="text-error">
              <flash-message :errors="errorMessages"></flash-message>
            </div>
          </div>
        </div>
      </md-card-content>
      <md-card-content>
        <form method="get" novalidate @submit.prevent="submitForm">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-25 md-small-size-100" v-if="isSuperUser()">
              <md-field>
                <label>部⾨</label>
                <md-select name="groupSelected" id="groupSelected" v-model="form.group_id"
                           :disabled="sending || loading || downloading" ref="mdSelectGroup">
                  <md-option :value="unspecified">{{ unspecifiedLabel }}</md-option>
                  <md-option v-for="(group) in selectableGroups" v-bind:key="'group-' + group.group_id"
                             :value="group.group_id">
                    {{ group.name }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25 md-small-size-100">
              <md-field>
                <label>種類</label>
                <md-select name="pdfType" id="selectLog" v-model="form.pdfType"
                           :disabled="sending || loading || downloading"
                           ref="mdSelectPdf">
                  <md-option :value="unspecified">{{ unspecifiedLabel }}</md-option>
                  <md-option v-for="(pdfType, index) in pdfTypes" :key="'pdf-type-' + index" :value="pdfType.code">
                    {{ pdfType.name }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <!--↓新-->
          <div class="md-layout md-size-60 md-gutter md-alignment-center-left">
            <label class="md-layout md-layout-item md-size-10 md-small-size-100">
              期間
            </label>
            <div class="md-layout md-layout-item md-size-40 md-alignment-center-left">
              <md-field class="md-layout-item md-size-45 md-small-size-100">
                <date-picker :disabled-dates="calendarState.disableFrom" v-model="form.startDate"
                             :disabled="sending || loading || downloading"
                ></date-picker>
              </md-field>
              <label class="md-alignment-center-center md-layout md-layout-item md-size-10">〜</label>
              <md-field class="md-layout-item md-size-45 md-small-size-100">
                <date-picker :disabled-dates="calendarState.disableTo" v-model="form.finishDate"
                             :disabled="sending || loading || downloading"></date-picker>
              </md-field>
            </div>
            <md-button class="md-primary md-raised md-layout-item md-size-15 md-small-size-100"
                       type="submit"
                       :disabled="sending || loading || downloading">
              <md-icon>search</md-icon>
              <span>表示する</span>
            </md-button>
            <md-button class="md-primary md-raised md-layout-item md-size-20 md-small-size-100"
                       type="button"
                       :disabled="usages.length === 0 || sending || loading || downloading"
                       @click.prevent="download()">
              <md-icon>file_download</md-icon>
              <span>ダウンロード</span>
            </md-button>
          </div>
        </form>
        <loading-spinner v-if="sending"></loading-spinner>
        <div class="md-layout" v-else-if="!noData">
          <div class="md-layout-item md-size-100">
            <!-- 集計<全体> -->
            <md-table>
              <md-table-row>
                <md-table-head><span>ユーザー名</span></md-table-head>
                <md-table-head><span>部門</span></md-table-head>
                <md-table-head v-for="(pdfType, index) in pdfTypes" v-bind:key="'pdf-key-' + index"
                               v-if="hasSum(pdfType.code)"
                ><span>{{ pdfType.name }}</span></md-table-head>
              </md-table-row>
              <md-table-row v-for="(row, index) in sortedUsages" v-bind:key="'row-account-' + index"
              >
                <md-table-cell class="content-style">{{ row.account_name }}</md-table-cell>
                <md-table-cell class="content-style">{{ row.group_name }}</md-table-cell>
                <md-table-cell v-for="(pdfType, pdfIndex) in pdfTypes" v-bind:key="'pdf-row-key-' + pdfIndex"
                               v-if="hasSum(pdfType.code)"
                >{{ row['count_pdf_type_' + pdfType.code] }}
                </md-table-cell>
              </md-table-row>
              <md-table-row class="md-table-row-total">
                <md-table-cell class="content-style" colspan="2" style="text-align: right">合計</md-table-cell>
                <md-table-cell v-for="(pdfType, pdfIndex) in pdfTypes" v-bind:key="'pdf-row-key-' + pdfIndex"
                               v-if="hasSum(pdfType.code)"
                >{{ total['count_pdf_type_' + pdfType.code] }}
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <md-dialog :md-fullscreen="false" :md-active.sync="showConfirmModal">
      <md-dialog-title>ダウンロード</md-dialog-title>
      <md-dialog-content>
        利用状況を表示させてからダウンロードしてください。
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :class="'md-primary'" @click="showConfirmModal = false">OK</md-button>
      </md-dialog-actions>
    </md-dialog>
  </main>
</template>

<script>
import moment                                         from 'moment';
import DatePicker                                     from "../../../components/DatePicker";
import FlashMessage                                   from '../../../components/FlashMessage';
import LoadingSpinner                                 from '../../../components/LoadingSpinner';
import {apiClientWithUserToken as apiClient, apiList} from '../../../modules/apiClient';
import Common                                         from '../../../modules/common';
import CommonMixin                                    from '../../../mixins/commonMixin';
import DownloadMixin                                  from "../../../mixins/downloadMixin";

export default {
  name      : "UserUsage",
  components: {LoadingSpinner, FlashMessage, DatePicker},
  mixins    : [
    CommonMixin,
    DownloadMixin,
  ],
  data      : () => ({
    form            : {
      pdfType   : null,
      startDate : moment().subtract(3, 'months').format(Common.momentConst.dateFormat),
      finishDate: moment().format(Common.momentConst.dateFormat),
      group_id  : null,
    },
    formSearched    : {
      pdfType   : null,
      startDate : moment().subtract(3, 'months').format(Common.momentConst.dateFormat),
      finishDate: moment().format(Common.momentConst.dateFormat),
      group_id  : null,
    },
    calendarState   : {
      disableFrom: {
        to  : moment().subtract(3, 'months').subtract(1, 'days').toDate(),
        from: moment().hour(23).minute(59).second(59).toDate(), // 今日の23:59:59まで
      },
      disableTo  : {
        to  : moment().subtract(3, 'months').subtract(1, 'days').toDate(),
        from: moment().hour(23).minute(59).second(59).toDate(), // 今日の23:59:59まで
      }
    },
    response        : null,
    usages          : [],
    total           : [],
    selectableGroups: [],
    groups          : [],
    pdfTypes        : [],
    noData          : true,
    loading         : false,
    showConfirmModal: false,
    submitted       : false,
  }),
  mounted   : function () {
    this.loading = true;
    this.pdfTypes.push(...Common.specialPdfTypesForUser);
    this.pdfTypes.push(...Common.pdfTypes);
    this.getGroupList();
  },
  updated() {
    if (this.$refs['mdSelectGroup'] && this.$refs['mdSelectGroup'].$el) {
      this.$refs['mdSelectGroup'].$el.validity = {};
    }
    if (this.$refs['mdSelectPdf'] && this.$refs['mdSelectPdf'].$el) {
      this.$refs['mdSelectPdf'].$el.validity = {};
    }
  },
  computed: {
    /**
     * ソートされた利用状況レコード
     *
     * @returns {{account_id:int, account_name:string, group_id:int, group_name:string, count_pdf_type_N:int}[]}
     */
    sortedUsages() {
      return this.usages.sort((a, b) => {
        const compare = a.group_id - b.group_id;
        return compare !== 0 ? compare : a.account_id - b.account_id;
      });
    }
  },
  methods : {
    /**
     * GET UserUsage from API
     * APIから利用状況を取得
     */
    submitForm() {
      this.sending      = true;
      const data        = {
        'group_id'          : this.form.group_id === this.unspecified ? null : this.form.group_id,
        'pdf_type'          : this.form.pdfType === this.unspecified ? null : this.form.pdfType,
        'requested_at_begin': moment(this.form.startDate).format(Common.momentConst.startDateFormat),
        'requested_at_end'  : moment(this.form.finishDate).format(Common.momentConst.endDateFormat),
      };
      this.formSearched = Object.assign({}, this.form);
      apiClient
          .get(apiList.user.usage, {params: data})
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.usages   = [];
              this.noData   = true;
              return;
            }
            this.submitted = true;
            this.usages    = response.data.usages;
            this.total     = response.data.total;
            this.noData    = !(this.usages && this.usages.length > 0);
          })
          .catch(error => {
            this.errorMessages = [error.message];
            this.noData        = true;
          })
          .finally(() => {
            if (this.noData) {
              this.sending = false;
              return;
            }
            this.sending = false;
          });
    },
    download() {
      const self = this;
      if (!this.submitted ||
          this.formSearched.group_id !== this.form.group_id ||
          this.formSearched.pdfType !== this.form.pdfType ||
          this.formSearched.startDate !== this.form.startDate ||
          this.formSearched.finishDate !== this.form.finishDate) {
        this.showConfirmModal = true;
        return;
      }
      const data            = {
        'group_id'          : this.form.group_id === this.unspecified ? null : this.form.group_id,
        'pdf_type'          : this.form.pdfType === this.unspecified ? null : this.form.pdfType,
        'requested_at_begin': moment(this.form.startDate).format(Common.momentConst.startDateFormat),
        'requested_at_end'  : moment(this.form.finishDate).format(Common.momentConst.endDateFormat),
        'output'            : '1',
      };
      this.showConfirmModal = false;
      this.downloading      = true;
      apiClient
          .get(apiList.user.usage, {params: data})
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            self.downloadFile(response.data.path, response.data.path, self.downloadType.excel)
                .then((result) => {
                  self.downloading = false;
                  if (!result) {
                    throw Error(Common.messages.errorDownload)
                  }
                });
          })
          .catch(error => {
            self.downloading   = false;
            self.errorMessages = [error.message];
          });
    },
    getGroupList() {
      if (this.isGroupAdmin()) {
        this.selectableGroups = this.onlyCurrentGroup();
        this.form.group_id    = this.selectableGroups.length > 0 ? this.selectableGroups[0].group_id : this.unspecified;
        this.loading          = false;
        return;
      }
      apiClient
          .get(apiList.jon.groups.list)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.selectableGroups = this.parsedGroups(response.data.data, 0);
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.loading = false;
          });
    },
    hasSum(pdfType) {
      return this.formSearched.pdfType === null || this.formSearched.pdfType === this.unspecified || this.formSearched.pdfType === pdfType;
    },
    getMaxDate() {
      return this.form.finishDate;
    },
    getMinDate() {
      return this.form.startDate;
    },
    getPdfTypeName(code) {
      const pdfType = this.pdfTypes.filter(function (data) {
        return data.code === code;
      });
      if (pdfType.length > 0) {
        return pdfType[0].name;
      }
      return null;
    },
  },
}
</script>

<style lang="scss" scoped>
.md-table {
  margin-bottom: 30px;

  ::v-deep(table) {
    border-collapse: separate;
  }

  .md-table-row {
    .md-table-head {
      ::v-deep(.md-table-head-container) {
        height: 46px !important;
      }
    }

    &-total {
      .md-table-cell {
        border-top: 1px solid gray;
      }
    }
  }
}

</style>
